import { Inject, Injectable } from '@angular/core';
import { IFilterService, IScopedLogbookResponse } from './service.class';
import { HttpClient } from '@angular/common/http';
import {
  IScopedLogbookDropdownData,
} from '../../component/filter/filter.class';

@Injectable({
  providedIn: 'root',
})
export class ScopedLogbookService implements IFilterService {
  constructor(public http: HttpClient, @Inject('API_BASE_URL') private readonly baseUrl: string) {}

  private readonly routes: string = 'logbooks/versions-form-assignments';

  getScopedLogbooks(): Promise<IScopedLogbookDropdownData[]> {
    return this.getData();
  }

  public getData(): Promise<IScopedLogbookDropdownData[]> {
    return new Promise((resolve, reject) => {
      // @ts-ignore
      this.http.get(`${this.baseUrl}/${this.routes}`).subscribe((response: IScopedLogbookResponse) => {
        if (response.hasOwnProperty('data')) {
          resolve(response.data);
        } else {
          reject();
        }
      });
    });
  }
}
